/* eslint-disable max-len */
export const itIT = {
  all: "Tutti",
  auth: {
    account_merge_required: "Fusione account richiesta",
    errors: {
      email_already_in_use: "Questo indirizzo email è già in uso",
      invalid_email: "Email non valida",
      popup_blocked: "Popup bloccato",
      too_many_requests: "Troppe richieste",
      user_disabled: "Utente disabilitato",
      user_not_found: "Utente non trovato",
      weak_password: "Password troppo debole",
    },
    login_with_apple: "Accedi con Apple",
    login_with_facebook: "Accedi con Facebook",
    login_with_google: "Accedi con Google",
    password_reset_sent: "Email di ripristino inviata",
  },
  common: {
    close_modal: "Chiudi modale",
  },
  company: {
    load_error: "Errore di caricamento",
  },
  company_info: {
    closed_now: "Chiuso ora",
    more_info: "Più informazioni",
    open_now: "Aperto ora",
  },
  dashboard: {
    bookings: {
      actions: {
        cancel: "Cancel",
        confirm: "Confermare",
        deny: "Negare",
        edit: "Modificare",
        view: "View",
      },
      bulk: {
        cancel: "Cancel",
        confirm: "Confirm",
        selected: "Selected",
      },
      bulk_update_fail: "Bulk update fail",
      bulk_update_partial_fail: "Bulk update partial fail",
      cancel: "Cancel",
      cancel_booking: "Cancel booking",
      cancel_fail: "Impossibile annullare la prenotazione, riprova",
      choose_time: "Scegli un orario",
      columns: {
        actions: "Azioni",
        customer_email: "Email del cliente",
        customer_name: "Nome del cliente",
        datetime: "Data della prenotazione",
        seats: "Posti",
        status: "Status",
      },
      concierge: {
        back: "Torna indietro",
        booked: "Prenotato il",
        camera_error: "Camera error",
        camera_generic_error: "Camera generic error",
        camera_not_found: "Camera not found",
        camera_permission_denied: "Camera permission denied",
        closereader: "Chiudi lettore",
        cod: "Codice",
        confirm: "Conferma prenotazione",
        confirmed: "Persone confermate",
        contact: "Qualche domanda? Contatta il manager o l'amministratore.",
        hello: "Salve Sig. Concierge!",
        is_invalid: "Questa prenotazione è al di fuori del periodo di utilizzo.",
        last_scan_id: "id: {{booking_id}}",
        loading: "Caricamento dati prenotazione...",
        mail: "Email",
        name: "Nome",
        not_found: "Prenotazione non trovata",
        openreader: "Apri lettore",
        phone: "Telefono",
        recomendation: "Per favore leggi un altro codice QR e riprova!",
        remain: "Rimanenti",
        scancode: "Lettura codice QR della prenotazione",
        scanned: "Prenotazione letta",
        seatsfor: "Posti per",
        state: "Stato",
        switch_camera: "Cambia fotocamera",
        usereader: "Usa il lettore qui sotto per leggere il codice di prenotazione.",
      },
      created_at: "Created at",
      created_fail: "Impossibile creare la nuova prenotazione, riprova.",
      created_success: "Nuova prenotazione creata!",
      customer: {
        bookings: "Le tue prenotazioni",
        complete: "Profilo completo",
        email: "Abbiamo inviato un'email di conferma, controlla la tua casella di posta.",
        menu: "Menu",
        none: "Non hai nessuna prenotazione.",
        profile_updated: "Profilo aggiornato con successo!",
        qr_info: "La tua prenotazione è stata inviata via email, ma può essere visualizzata cliccando su 'Vedi Codice QR'.",
        qr_modal_description: "Mostra questo codice QR al ristorante per confermare la tua prenotazione.",
        qr_modal_title: "Codice QR della Prenotazione",
        title: "Prenotazioni",
        view_qr: "Vedi Codice QR",
      },
      delete_success: "Prenotazione annullata!",
      dialogs: {
        confirmed: {
          message: "Vuoi confermare la prenotazione per {{booking_title}} posti? ",
          success: "Prenotazione confermata!",
          title: "Conferma prenotazioni",
        },
        edit: "Modifica prenotazione",
        fail: {
          message: "Qualcosa è andato storto mentre cercavamo di confermare questa prenotazione, riprova!",
          title: "Ops!",
        },
      },
      edit_booking: "Edit booking",
      empty_suggestion: "Empty suggestion",
      filters: {
        all_status: "All status",
        date: "Date",
        date_range: "Date range",
        filters: "Filters",
        search: "Ricerca",
        search_placeholder: "Cerca prenotazioni...",
        status: "Stato della prenotazione",
      },
      final_status: "Lo stato di questa prenotazione non può più essere modificato.",
      how_many: "Tavolo per quante persone?",
      load_error: "Load error",
      no_availability: "No availability",
      no_bookings_concierge: "No bookings concierge",
      no_bookings_customer: "No bookings customer",
      no_date: "Impossibile caricare le informazioni per la data selezionata, scegli un'altra data e riprova.",
      notes: "Notes",
      people_count: "People count",
      refresh_error: "Refresh error",
      reservation: "Reservation",
      showing_count: "Showing count",
      status: {
        all: "All",
        canceled: "Annullata",
        cancelled: "Cancelled",
        completed: "Completed",
        confirmed: "Confermata",
        created: "In attesa di conferma",
        denied: "Negata",
        noshow: "Mancata presenza",
        partial: "In attesa dei clienti ",
        pending: "Pending",
        used: "Già utilizzata",
      },
      status_error: "Status error",
      status_label: "Status label",
      table: {
        actions: "Actions",
        customer: "Customer",
        datetime: "Datetime",
        id: "Id",
        seats: "Seats",
        status: "Status",
      },
      title: "Lista Prenotazioni",
      total_count: "Total count",
      update_fail: "Update fail",
      weekdays: {
        friday: "Ven",
        monday: "Lun",
        saturday: "Sab",
        sunday: "Dom",
        thursday: "Gio",
        tuesday: "Mar",
        wednesday: "Mer",
      },
    },
    categories: {
      actions: {
        delete: "Elimina",
        disable: "Disattiva",
        edit: "Modifica",
        enable: "Abilita",
      },
      columns: {
        actions: "Azioni",
        description: "Descrizione",
        langs: "Lingue registrate",
        name: "Nome",
        order: "Ordine",
        status: "Stato",
      },
      dialogs: {
        delete: {
          message: "Vuoi davvero eliminare la categoria '{{category_name}}'?",
          title: "Elimina categoria",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "Tutte le lingue sono obbligatorie",
        basic_info: "Informazioni di base",
        create_title: "Nuova Categoria",
        edit_title: "Modifica Categoria",
        description: "Descrizione",
        enabled: "Abilita",
        name: "Nome della Categoria",
        order: "Ordine",
        order_placeholder: "1",
        texts: "Informazioni della Categoria",
      },
      new: "Nuova categoria",
      not_found: "Categoria non trovata, riprova!",
      status: {
        disabled: "Disabilitato",
        enabled: "Abilitato",
      },
      title: "Lista Categorie",
    },
    clear_filter: "Cancella ricerca e filtri",
    company: {
      booking_title: "Prenotazioni",
      bookings_title: "Orario Prenotazioni",
      colors_title: "Colori e Stili",
      disclaimers_title: "Note Legali del Menu",
      form: {
        booking_approval: "Approva prenotazioni",
        booking_interval: "Intervallo tra le prenotazioni",
        booking_max_seats: "Numero massimo di posti",
        booking_toleration: "Tolleranza della prenotazione",
        currency: "Valuta",
        end: "Orario finale",
        lang: "Lingua predefinita",
        langs: "Lingue disponibili",
        name: "Nome",
        period: "Periodo",
        phone: "Numero di telefono",
        pics: "Articoli con foto",
        qrcode_bg: "Colore di sfondo del Codice QR",
        qrcode_border: "Colore del bordo del Codice QR",
        required: "Campo obbligatorio",
        seats: "Posti",
        start: "Orario iniziale",
        street_address: "Indirizzo",
        theme: "Colore del tema",
        timezone: "Fuso orario dell'azienda",
        weekday: "Giorno della settimana",
      },
      periods_title: "Orario del Menu",
      request_error: "Impossibile caricare le informazioni dell'azienda",
      runnings_title: "Orari di Apertura",
      time_title: "Informazioni sul Fuso orario",
      title: "Azienda",
    },
    discounts: {
      columns: {
        actions: "Azioni",
        items: "Articoli",
        name: "Nome",
        percent: "Percentuale %",
        period: "Periodo",
        type: "Tipo",
      },
      dialogs: {
        delete: {
          message: "Vuoi davvero eliminare lo sconto '{{discount_name}}' ?",
          title: "Elimina sconto",
        },
      },
      enabled: "Abilitato",
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        apply_to: "Applica a",
        basic_info: "Informazioni di base",
        discount_info: "Informazioni sullo sconto",
        percent_placeholder: "0",
      },
      items: "Articoli (Cibi / Categorie)",
      name: "Nome",
      new: "Nuovo sconto",
      not_found: "Sconto non trovato, seleziona un altro e riprova!",
      percent: "Percentuale %",
      period: "Periodo",
      title: "Sconti",
      type: "Tipo",
      types: {
        category: "Categoria",
        food: "Cibo",
      },
    },
    filters: {
      chips_label: "Filtri attivi",
      expand_label: "Espandi filtri",
      summary_label: "Riepilogo filtri attivi",
    },
    foods: {
      actions: {
        delete: "Elimina",
        disable: "Disattiva",
        edit: "Modifica",
        enable: "Abilita",
        price: "Modifica Prezzo",
      },
      card: {
        available_days_label: "Giorni disponibili",
        available_periods_label: "Periodi disponibili",
        categories_label: "Categorie",
        featured_label: "In evidenza",
        featured_tooltip: "Articolo in evidenza",
        has_image_label: "Ha un'immagine",
        has_image_tooltip: "L'articolo ha un'immagine",
        indicators_label: "Indicatori dell'articolo",
        original_price_label: "Prezzo originale",
        price_label: "Prezzo",
        promo_price_label: "Prezzo promozionale",
        quick_actions_label: "Azioni rapide",
        status_badges_label: "Badge di stato",
      },
      columns: {
        actions: "Azioni",
        categories: "Categoria",
        langs: "Lingue registrate",
        name: "Nome",
        periods: "Periodi",
        price: "Prezzo",
        status: "Stato",
        weekdays: "Giorni della settimana",
      },
      dialogs: {
        delete: {
          message: "Vuoi davvero eliminare l'articolo '{{food_name}}'?",
          title: "Elimina Articolo",
        },
        disable: {
          message: "Vuoi davvero disabilitare l'articolo '{{food_name}}'?",
          title: "Disabilita Articolo",
        },
        enable: {
          message: "Vuoi davvero abilitare l'articolo '{{food_name}}'?",
          title: "Abilita Articolo",
        },
        price: "Modifica Prezzo",
      },
      drag_warning: "Seleziona esattamente una categoria per ordinare trascinando gli articoli",
      featured: {
        all: "All",
        featured: "Featured",
        not_featured: "Not featured",
      },
      filters: {
        availability: "Availability",
        categories: "Categorie",
        classification: "Classification",
        featured: "In evidenza",
        filter_active: "filtro attivo",
        filters_active: "filtri attivi",
        inclusive: "Inclusive",
        periods: "Fasce orarie",
        preview: "Vedi menu",
        search: "Ricerca",
        search_text: "Search text",
        status: "Item Status",
        weekdays: "Giorni della settimana",
      },
      form: {
        all_days: "Tutti i giorni",
        all_languages_required: "Tutte le lingue sono obbligatorie",
        all_periods: "Tutti i periodi",
        availability: "Disponibilità",
        basic_info: "Informazioni di base",
        categories: "Categorie",
        categorization: "Categorizzazione",
        change_image: "Cambia immagine",
        code: "Codice",
        coffee: "Colazione",
        create_title: "Nuovo Articolo",
        description: "Descrizione",
        dine: "Cena",
        edit_title: "Modifica Articolo",
        enabled: "Abilita",
        featured: "In evidenza",
        friday: "Venerdì",
        image: "Immagine dell'articolo",
        lunch: "Pranzo",
        monday: "Lunedì",
        name: "Nome",
        new_category: "Nuova Categoria",
        new_tag: "Nuovo Tag",
        no_categories: "Nessuna categoria disponibile",
        no_tags: "Nessun tag disponibile",
        order: "Ordine",
        periods: "Periodi",
        price: "Prezzo",
        price_label: "Prezzo",
        promo_price: "Prezzo promozionale",
        promo_price_label: "Prezzo promozionale",
        saturday: "Sabato",
        snack: "Spuntino",
        sunday: "Domenica",
        tags: "Tag",
        texts: "Informazioni dell'Articolo",
        thursday: "Giovedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
        weekdays: "Giorni",
      },
      grid_label: "Articoli alimentari",
      new: "Nuovo Articolo",
      not_found: "Articolo non trovato, seleziona un altro e riprova!",
      periods: {
        "": "",
        all: "All",
        coffee: "Coffee",
        dine: "Dine",
        lunch: "Lunch",
        snack: "Snack",
      },
      quick_filters: {
        active: "Attivi",
        featured: "In evidenza",
        inactive: "Inattivi",
        on_sale: "In promozione",
      },
      statistics: {
        disabled: "Disabilitati",
        enabled: "Abilitati",
        featured: "In evidenza",
        showing: "Visualizzazione",
      },
      statistics_label: "Riepilogo statistiche alimentari",
      status: {
        all: "All",
        disabled: "Disabilitato",
        enabled: "Abilitato",
      },
      title: "Lista Articoli del Menu",
      view: {
        grid: "Griglia",
        label: "Visualizzazione",
        table: "Tabella",
      },
      weekdays: {
        "": "",
        all: "All",
        friday: "Venerdì",
        monday: "Lunedì",
        saturday: "Sabato",
        sunday: "Domenica",
        thursday: "Giovedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
      },
    },
    highlights: "In evidenza",
    image: {
      error: "Qualcosa è andato storto caricando la tua immagine, riprova.",
      maxsize: "Questa immagine supera la dimensione massima consentita, invia un'immagine di massimo 5MB.",
      remove: "Qualcosa è andato storto eliminando la tua immagine, riprova.",
    },
    menu: {
      bookings: "Prenotazioni",
      categories: "Categorie",
      change_password: "Cambia Password",
      company: "Azienda",
      discounts: "Sconti",
      foods: "Articoli",
      logout: "Esci",
      print_menu: "Stampa Menu",
      profile: "Profilo",
      reader: "Lettore QR",
      tags: "Tag",
      users: "Utenti",
    },
    no_dishes: "Non ci sono piatti nel menu oggi.",
    not_found: "Non abbiamo trovato nessun piatto corrispondente alla tua ricerca.",
    notifications: {
      not_supported: "Le notifiche non sono supportate in questo browser",
    },
    reader: {
      people_count: "Numero di persone",
    },
    search_dish: "Cerca il tuo piatto",
    stats: {
      all_time: "Storico totale",
      canceled: "Annullate",
      canceled_subtitle: "Prenotazioni annullate",
      confirmed: "Confermate",
      confirmed_subtitle: "Prenotazioni confermate",
      occupancy_rate: "Tasso di occupazione",
      seats: "Posti",
      today_bookings: "Prenotazioni oggi",
      today_subtitle: "Prenotazioni per oggi",
      total_bookings: "Totale prenotazioni",
      used: "Utilizzate",
      used_subtitle: "Prenotazioni utilizzate",
    },
    tags: {
      columns: {
        actions: "Azioni",
        langs: "Lingue registrate",
        name: "Nome",
      },
      dialogs: {
        delete: {
          message: "Vuoi davvero eliminare il tag '{{category_name}}'?",
          title: "Elimina tag",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "Tutte le lingue sono obbligatorie",
        create_title: "Nuovo Tag",
        edit_title: "Modifica Tag",
        name: "Nome del Tag",
        texts: "Informazioni del Tag",
      },
      new: "Nuovo tag",
      not_found: "Tag non trovato, riprova!",
      title: "Lista Tag",
    },
    title: "Dashboard ZMenu",
    users: {
      actions: {
        delete: "Elimina",
        edit: "Modifica",
      },
      columns: {
        actions: "Azioni",
        fullname: "Nome completo",
        mail: "Email",
        scopes: "Permessi",
        username: "Nome utente",
      },
      dialogs: {
        delete: {
          message: "Vuoi davvero eliminare l'utente '{{user_name}}'?",
          title: "Elimina utente",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        basic_info: "Informazioni di base",
        confirm_password: "Conferma Password",
        create_title: "Nuovo Utente",
        edit_title: "Modifica Utente",
        fullname: "Nome completo",
        mail: "Email",
        password: "Password",
        permissions: "Permessi",
        scopes: "Permessi",
        security: "Sicurezza",
        username: "Nome utente",
      },
      new_singular: "Nuovo Utente",
      not_found: "Utente non trovato, selezionane un altro e riprova!",
      profile: {
        change_password: "Cambia Password",
        title: "Profilo utente",
      },
      title: "Lista utenti",
    },
    password_scores: {
      very_weak: "Molto Debole",
      weak: "Debole",
      okay: "Accettabile",
      good: "Buona",
      strong: "Forte",
    },
  },
  dialogs: {
    attention: "Attenzione",
    cancel: "Annulla",
    close: "Chiudi",
    confirm: "Sì",
    confirmation: "Conferma",
    edit: "Edit",
    fail: "Ops!",
    gone_wrong: "Qualcosa è andato storto, riprova!",
    invalid_login: "Email o password non valide, riprova",
    login_error: "Errore di accesso. Riprova.",
    not_allowed: "Questo utente non è autorizzato a usare questo modulo.",
    same_user: "Esiste già un account registrato con l'email {{ email }}. Prova ad accedere con quell'account invece di associare questo account social.",
    submit: "Invia",
    success: "Successo",
  },
  password_scores: {
    very_weak: "Molto Debole",
    weak: "Debole",
    okay: "Accettabile",
    good: "Buona",
    strong: "Forte",
  },
  drag_limited_to: "Trascinamento limitato a",
  footer: "fatto con amore da ZMenu ©",
  forms: {
    common: {
      price_placeholder: "0,00",
      time_placeholder: "HH:mm",
    },
  },
  gone_wrong: "Qualcosa è andato storto, riprova!",
  loading: "Caricamento",
  login: {
    email: "Email",
    facebook: "Facebook",
    google: "Google",
    password: "Password",
    sigin_apple: "Accedi con Apple",
    sigin_facebook: "Accedi con Facebook",
    sigin_google: "Accedi con Google",
    signup: "Registrati",
    submit: "Entra",
    username: "Utente",
  },
  logout: "Esci",
  module: {
    disabled: "Modulo disabilitato, contatta il Team di ZMenu per abilitarlo.",
  },
  network: {
    back_online: "Connessione ripristinata",
    offline: "Nessuna connessione",
    offline_error: "Errore di connessione. Controlla internet.",
  },
  of: "di",
  pdf: {
    categories: "Categorie",
    clear_all: "Cancella tutto",
    converting_category: "Convertendo categoria {{current}} di {{total}}...",
    description: "Seleziona le categorie che vuoi includere nel tuo menu per la stampa",
    download: "Scarica",
    download_success: "PDF scaricato con successo!",
    drag_to_reorder: "Trascina per riordinare le categorie nel PDF",
    food_count: "{{count}} elementi",
    generate: "Genera PDF",
    generation_error: "Errore nella generazione del PDF",
    generation_success: "PDF generato con successo!",
    include_prices: "Includi prezzi",
    language: "Lingua",
    loading: "Caricamento...",
    merging_pdfs: "Unendo PDFs...",
    no_categories: "Nessuna categoria disponibile",
    no_categories_selected: "Seleziona almeno una categoria",
    options: "Opzioni",
    preparing_menu: "Preparando menu...",
    preview: "Anteprima PDF",
    preview_html: "Anteprima HTML",
    preview_html_title: "Anteprima HTML",
    preview_title: "Anteprima del PDF",
    select_all: "Seleziona tutto",
    selected_count: "{{count}} di {{total}} categorie selezionate",
    settings: "Impostazioni PDF",
    title: "Genera Menu PDF",
  },
  signup: {
    complete: "Completa il tuo profilo",
    confirm_password: "Conferma la password scelta",
    email: "Email di contatto",
    name: "Nome completo",
    password: "Scegli la tua password",
    phone: "Telefono / Cellulare",
    submit: "Registrati",
    title: "Registrati",
  },
  validation: {
    email: "Email",
    error: "Error",
    maxLength: "Max length",
    minLength: "Min length",
    pattern: "Pattern",
    phone: "Phone",
    required: "Required",
  },
};